module.exports = __webpack_public_path__ + "static/media/Crown-active.59122365.svg";